import React, { useState } from 'react';
import ICDConfiguration from './ICDConfiguration';
import PortRemarksConfiguration from './PortRemarksConfiguration';

export default function PortConfiguration() {
    const [activeTab, setActiveTab] = useState('icd');

    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
            <h2>Port Configurations</h2>

            <div className="custom-tabs-container">
                <button
                    className={`custom-tab ${activeTab === 'icd' ? 'active' : ''}`}
                    onClick={() => setActiveTab('icd')}
                >
                    ICD Config
                </button>
                <button
                    className={`custom-tab ${activeTab === 'remarks' ? 'active' : ''}`}
                    onClick={() => setActiveTab('remarks')}
                >
                    Port Remarks Config
                </button>
            </div>

            <div className="tab-content" style={{ marginTop: '20px' }}>
                {activeTab === 'icd' && <ICDConfiguration />}
                {activeTab === 'remarks' && <PortRemarksConfiguration />}
            </div>
        </div>
    );
}